import 'whatwg-fetch';
import 'babel-polyfill';
import { getLocale } from '@/assets/js/utils/browser';
import { DEFAULT_LOCALE } from '@/utils/Constants';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Router from 'vue-router';
import moment from 'moment';
import jquery from 'jquery';

// plugins
import flatPickr from 'vue-flatpickr-component';
import flatpickr from 'flatpickr'; // eslint-disable-line
import { Russian } from 'flatpickr/dist/l10n/ru'; // eslint-disable-line
import Vuelidate from 'vuelidate';
import VueTippy from 'vue-tippy';

import '@/assets/js/utils/sentry';
import GTM from '@/assets/js/utils/gtm';

import App from './App.vue';
import router from './router';
import store from './store';
import * as filters from './utils/Filters';
import apolloProvider from './apollo';

window.$ = jquery;
window.jQuery = jquery;

GTM();

moment.defineLocale('lt', {
  parentLocale: 'en',
});

moment.locale(getLocale(DEFAULT_LOCALE));

if (moment.locale() === 'ru') {
  // set flatpickr -default lang
  flatpickr.localize(Russian);
}

// plugins init
Vue.use(Router);

Vue.use(flatPickr);

Vue.use(Vuelidate);

Vue.use(VueTippy);

// set global filters
Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter]);
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  provide(instance) {
    return apolloProvider(instance);
  },
  template: '<App/>',
  components: {
    App,
  },
});

// отключили jivosite
// jivo(moment.locale());



// WEBPACK FOOTER //
// ./src/main.js